module.exports = __webpack_public_path__ + "static/img/star_person_team.a2741711.png";